import { Box, Tooltip, Typography, Stack } from '@mui/material'
import { Show } from 'components'
import CustomSwitch from './custom-switch'

type Value = {
  model: string
  explanation?: boolean
}
function ScoreModels({
  value,
  label,
  onChange,
  isLoading,
  options,
  availableModels,
}: {
  value: Value[]
  label: string
  onChange: (newValue: Value[]) => void
  isLoading: boolean
  options: {
    label: string
    key: string | number
  }[]
  availableModels: { model: string; canBeChanged: boolean }[]
}) {
  const handleUpdate = (
    field: 'model' | 'explanation',
    curValue: boolean,
    model: string,
  ) => {
    switch (field) {
      case 'model':
        if (!curValue) {
          if (model === 'BOHR') {
            onChange([...value, { model, explanation: false }])
          } else {
            onChange([...value, { model }])
          }
        } else {
          onChange(value.filter((x) => x.model !== model))
        }
        break
      case 'explanation':
        break

      default:
        break
    }
  }

  const handleValue = (value: Value[], model) => {
    if (value) {
      const modelValue = value.map((x) => x.model)
      return modelValue.includes(model)
    }
  }

  const checkIfDisabled = (model) => {
    const modelValue = availableModels.filter((x) => x.model === model)[0]
    return !modelValue.canBeChanged
  }

  return (
    <Show when={value}>
      <Stack spacing={1}>
        {availableModels.length ? (
          availableModels.map(({ model }) => (
            <Box key={model} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography
                variant="caption"
                fontWeight={600}
                color="text.secondary"
                sx={{ minWidth: 60, textTransform: 'uppercase', letterSpacing: '0.5px' }}
              >
                {model}
              </Typography>
              <Tooltip
                placement="top"
                title={
                  checkIfDisabled(model) ? 'This model cannot be changed' : ''
                }
              >
                <Box>
                  <CustomSwitch
                    isLoading={isLoading}
                    onChange={() =>
                      handleUpdate('model', handleValue(value, model), model)
                    }
                    value={handleValue(value, model)}
                    label=""
                  />
                </Box>
              </Tooltip>
            </Box>
          ))
        ) : (
          <Typography variant="body2" color="text.secondary">
            No available models
          </Typography>
        )}
      </Stack>
    </Show>
  )
}

export default ScoreModels
